import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, ListGroup, Alert } from 'react-bootstrap';
import emailjs from '@emailjs/browser';

const Contact = ({ texts }) => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: '',
    });
    const [sentEmails, setSentEmails] = useState([]);
    const [status, setStatus] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const templateParams = {
            name: formData.name,
            email: formData.email,
            message: formData.message,
        };

        emailjs
            .send(
                process.env.REACT_APP_EMAILJS_SERVICE_ID,
                process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
                templateParams,
                process.env.REACT_APP_EMAILJS_PUBLIC_KEY
            ).then(
            (response) => {
                console.log('Mail gönderildi:', response.status, response.text);
                setStatus('success');
                const newEmail = {
                    name: formData.name,
                    email: formData.email,
                    message: formData.message,
                    timestamp: new Date().toLocaleString(),
                };
                setSentEmails((prevEmails) => [...prevEmails, newEmail]);
                setFormData({ name: '', email: '', message: '' });
                setTimeout(() => setStatus(null), 3000);
            },
            (error) => {
                console.error('Mail gönderilemedi:', error);
                setStatus('error');
                setTimeout(() => setStatus(null), 3000);
            }
        );
    };

    return (
        <section id="contact" className="contact-section d-flex align-items-center">
            <Container>
                <h2 className="text-center mb-4">{texts.contact.title}</h2>
                <Row className="justify-content-center">
                    <Col xs={12} md={6}>
                        {status === 'success' && (
                            <Alert variant="success" className="text-center">
                                {texts.contact.form.successMessage || 'Mesajınız başarıyla gönderildi!'}
                            </Alert>
                        )}
                        {status === 'error' && (
                            <Alert variant="danger" className="text-center">
                                Mesaj gönderilirken bir hata oluştu.
                            </Alert>
                        )}
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3" controlId="formName">
                                <Form.Label>{texts.contact.form.name}</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder={texts.contact.form.namePlaceholder}
                                    required
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formEmail">
                                <Form.Label>{texts.contact.form.email}</Form.Label>
                                <Form.Control
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder={texts.contact.form.emailPlaceholder}
                                    required
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formMessage">
                                <Form.Label>{texts.contact.form.message}</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    placeholder={texts.contact.form.messagePlaceholder}
                                    required
                                />
                            </Form.Group>
                            <Button variant="primary" type="submit" className="w-100">
                                {texts.contact.form.button}
                            </Button>
                        </Form>

                        {sentEmails.length > 0 && (
                            <div className="mt-4">
                                <h3 className="text-center">Gönderilen Mesajlar</h3>
                                <ListGroup>
                                    {sentEmails.map((email, index) => (
                                        <ListGroup.Item key={index}>
                                            <strong>{email.name}</strong> ({email.email}) - {email.timestamp}
                                            <p>{email.message}</p>
                                        </ListGroup.Item>
                                    ))}
                                </ListGroup>
                            </div>
                        )}
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Contact;